<template>
  <slick ref="slick" :options="slickOptions">
    <div v-for="(content, index) in this.contents" :key="index">
      <b-img
        :src="require('@/assets/img/banners/' + content.img)"
        fluid
        style="margin: auto; cursor: pointer;"
        @click="openBanner(content.whereTo)"
      />
    </div>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Carousel_Banner',
  props: ['contents'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        // options can be used from the plugin documentation
        speed: 750,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: ''
      }
    }
  },
  methods: {
    /* vue slick prerequisites */
    next: function () {
      this.$refs.slick.next()
    },
    prev: function () {
      this.$refs.slick.prev()
    },
    reInit: function () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    },
    /* END vue slick prerequisites */

    openBanner: function (whereTo) {
      if (this.$router.currentRoute.name !== whereTo) {
        this.$router.push({ name: whereTo })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Carousel/Banner/Banner.vue